<template>
  <v-dialog persistent v-model="dialog" max-width="600px">
    <v-card style="border-radius: 20px; padding: 5px;">
      <v-card-title class="justify-center">
        <v-spacer></v-spacer>
        <h3>Invoice : {{ detailedItem.invoice_number }}</h3>
        <v-spacer></v-spacer>
        <span  @click="close"><v-icon>mdi-close</v-icon></span>
      </v-card-title>
      <V-divider class="mb-3"></V-divider>
      <div style="margin:0 20px">
        <table class="mb-3">
          <tbody>
            <tr>
              <th width="25%">Order Number</th>
              <th width="75%"> {{ detailedItem.order_number }} </th>
            </tr>
            <tr>
              <th width="25%">Order Date</th>
              <th width="75%"> {{ detailedItem.order_date }} </th>
            </tr>
            <tr>
              <th width="25%">Brand Name</th>
              <th width="75%"> {{ detailedItem.brand_name }} ({{ detailedItem.brand_code }}) </th>
            </tr>
            <tr>
              <th width="25%">Distributor</th>
              <th width="75%"> {{ detailedItem.distributor_name }} </th>
            </tr>
            <tr>
              <th width="25%">Total</th>
              <th width="75%"> {{ detailedItem.total_sales }} </th>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th>
                <v-icon>mdi-email-outline</v-icon>
                <span class="ml-3">{{ detailedItem.receiver_email }}</span>
              </th>
            </tr>
            <tr>
              <th>
                <v-icon>mdi-phone</v-icon>
                <span class="ml-3">{{ detailedItem.receiver_mobile }}</span>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <v-container>
        <v-card class="responsive m10">
          <table>
            <thead>
              <tr>
                <th>No.</th>
                <th>Voucher ID</th>
                <th>Activate Date</th>
                <th>Expired Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, index) in details" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{ detail.id_voucher }}</td>
                <td>{{ detail.date_activate }}</td>
                <td>{{ detail.date_expire }}</td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-container>
      <v-card-actions class="justify-center">
        <v-btn flat
          :loading="sending"
          :disabled="sending"
          class="green white--text"
          @click="sendDetail">
          Send Voucher List
          <span slot="loader" class="white--text">Sending...</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TransactionDetail',
  props: {
    detailedItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    details: {
      type: Array,
      default: () => {
        return []
      }
    },
    sending: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    close () {
      this.$emit('closePop', null)
      this.dialog = false
    },
    sendDetail () {
      this.$emit('send')
    },
    back () {
      this.dialog = false
    }
  },
  watch: {
    dialog () {
      setTimeout(() => {
        this.dialog = false
      }, 300)
    }
  }
}
</script>

<style scoped>
  .primary--text, .green--text {
    color: rgb(77, 189, 153)!important;
  }
  .green {
    background: rgb(77, 189, 153)!important;
  }
  .responsive {
    overflow-y: scroll;
    max-height: 300px;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #0000;
  }
  tr {
    border: 1px solid #0000;
  }
  thead {
    border: 2px solid darkgray !Important;
  }
  th, td {
    text-align: left;
    padding: 3px;
  }
  .m10 {
    margin: 10px 0 10px 0;
  }
</style>
